const isProduction = process.env.REACT_APP_NODE_ENV === '\'production\'';
const isStaging = process.env.REACT_APP_NODE_ENV === '\'staging\'';
const isDevelopment = process.env.NODE_ENV === 'development';

export { isProduction, isStaging, isDevelopment };

export const generateKey = (...args: any) => {
  return [...args, (Math.random() * 1e9).toString()]
    .filter((item) => !!item)
    .map((item) => {
      if (typeof item === 'object') return JSON.stringify(item);
      if (typeof item === 'function') return '';
      return item.toString();
    })
    .join('-');
};

export const isHTMLJunk = (html: string) => {
  const isJunk = html === ''
  || html === '<p><br /></p>'
  || html === '<p><span></span></p>'
  || html === '<p></p>'
  || html === '<div><p></p></div>'
  || html === '<div><p><br /></p></div>';

  return isJunk;
};

export function compare(a, b, field) {
  if (a[field] < b[field]) return -1;
  if (a[field] > b[field]) return 1;
  return 0;
}

export const alpha = (list) => {
  list.sort((a, b) => {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
  });
  return list;
};

export const alphaReverse = (list) => {
  list.sort((a, b) => {
    if (a < b) { return 1; }
    if (a > b) { return -1; }
    return 0;
  });
  return list;
};

export function isNotUndefined(arg) {
  return typeof arg !== 'undefined';
}


// WEBPACK FOOTER //
// ./src/utils/utils.js